import { Observable } from 'rxjs';
import { apiClient } from '~admin/client';
import { ResponseEntity } from '~client/model/response-entity';
import { NoArgTask, rxTask } from '~common/helper/mobx-tasks';

//TODO(Asif): Create internal models & mappers
export type LogoutTask = NoArgTask<ResponseEntity>;

const performLogout = (): Observable<ResponseEntity> => apiClient.adminController.logout$();

export const logoutTaskFactory = (): LogoutTask => rxTask(() => performLogout());



// WEBPACK FOOTER //
// ./interactor/login/perform-logout.ts